import * as React from "react"

import { Box } from "@chakra-ui/react"

export function Container({
  children,
  pb,
  pt,
  pr,
  pl,
  ...rest
}: {
  children: any
}) {
  return (
    <Box
      maxWidth={{ xl: 1100 }}
      m="0 auto"
      pt={pt || { base: `30px`, md: `50px` }}
      pl={pl || { base: `20px`, xl: 0 }}
      pr={pr || { base: `20px`, xl: 0 }}
      pb={pb || { base: `30px`, md: `50px` }}
      {...rest}
    >
      {children}
    </Box>
  )
}
